export function createInitials(name) {
    if (!name)
        return '';
    if (typeof name === 'number')
        return String(name);
    if (typeof name !== 'string')
        return '';
    return (name
        // Replace Unicode non-alphanumeric segments with a single space.
        .replace(/[^\p{L}\p{N}]+/gu, ' ')
        // Remove Unicode numbers.
        .replace(/\p{N}/gu, '')
        .split(' ')
        .map(function (str) { return str[0] || ''; })
        .join('')
        .trim()
        .toLocaleUpperCase());
}
